module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/plan1-1-26a0dab59166578c5ab84ffb35cea14a.webp";